import { Controller } from "@hotwired/stimulus"

// Scroll Reveal Animation Controller
// Add data-controller="scroll-reveal" to a container
// Add data-scroll-reveal-target="item" to each element to animate
// Optional: data-delay="100" to stagger animations
export default class extends Controller {
  static targets = ["item"]

  connect() {
    this.animatedItems = new Set()
    this.observer = new IntersectionObserver(
      (entries) => this.handleIntersection(entries),
      {
        threshold: 0.15,
        rootMargin: "0px 0px -50px 0px"
      }
    )

    this.itemTargets.forEach((item, index) => {
      // Add initial hidden state
      item.style.opacity = "0"
      item.style.transform = "translateY(30px)"
      item.style.transition = "opacity 0.6s ease-out, transform 0.6s ease-out"

      // Add stagger delay based on index or custom data attribute
      const delay = item.dataset.delay || (index * 100)
      item.style.transitionDelay = `${delay}ms`

      this.observer.observe(item)
    })
  }

  handleIntersection(entries) {
    entries.forEach((entry) => {
      if (entry.isIntersecting && !this.animatedItems.has(entry.target)) {
        this.animatedItems.add(entry.target)
        entry.target.style.opacity = "1"
        entry.target.style.transform = "translateY(0)"
      }
    })
  }

  disconnect() {
    if (this.observer) {
      this.observer.disconnect()
    }
  }
}




